/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */
'use strict'

// 3rd party
import React from 'react'

// walrus
import { accessibilityLabel } from '@components/kit/_support'
import ScrollView, { ScrollViewProps } from '@components/kit/scroll-view'

// lib
import Content from '@components/content'
import { ChatContext } from '../chat.web'
import FaxForm from './fax-form'
import Pharmacy from './pharmacy'

/* -----------------------------------------------------------------------------
 * Provider
 * -------------------------------------------------------------------------- */

export type ProviderProps = ScrollViewProps & {
  //TODO: Add props
}

function Provider({ ...rest }: ProviderProps) {
  const { userId } = React.useContext(ChatContext)

  return (
    <ScrollView {...accessibilityLabel('provider')} {...rest}>
      <Content>
        <Pharmacy />
        <FaxForm />
      </Content>
    </ScrollView>
  )
}

export default Provider
